export default __webpack_public_path__ + "static/media/limit-failure-dark.d9531837.png";